import React, { useEffect } from 'react';
import '../styles/AboutUs.css';
import Footer from '../components/Footer';
import Cubes from '../components/Cubes';

const AboutUs = () => {
  useEffect(() => {
    // Simple animation initialization
    try {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      }, observerOptions);

      // Observe all elements with data-aos attribute
      const animatedElements = document.querySelectorAll('[data-aos]');
      animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
      });

      return () => {
        observer.disconnect();
      };
    } catch (error) {
      console.log('Animation setup error:', error);
    }
  }, []);

  const showNotification = (message, type = 'info') => {
    // Remove existing notifications
    const existingNotifications = document.querySelectorAll('.notification');
    existingNotifications.forEach(notification => notification.remove());
    
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.innerHTML = `
      <div class="notification-content">
        <span class="notification-message">${message}</span>
        <button class="notification-close">&times;</button>
      </div>
    `;
    
    // Add styles
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#3b82f6'};
      color: white;
      padding: 16px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      max-width: 400px;
      animation: slideInRight 0.3s ease;
      font-family: 'Arial', sans-serif;
    `;
    
    // Add to page
    document.body.appendChild(notification);
    
    // Close button functionality
    const closeBtn = notification.querySelector('.notification-close');
    closeBtn.addEventListener('click', () => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    });
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }
    }, 5000);
  };


  return (
    <div className="aboutus-page" style={{backgroundColor: '#000', color: '#fff', minHeight: '100vh', position: 'relative'}}>
      {/* Background */}
      <div 
        className="aboutus-bg-image"
        style={{
          backgroundImage: "url('/assets/img/aboutusbg.avif')",
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: 1,
          pointerEvents: 'none'
        }}
      ></div>
      
      <div className="aboutus-overlay" style={{position: 'relative', zIndex: 2, background: 'rgba(0, 0, 0, 0.7)', width: '100%'}}>
        {/* Hero Section */}
        <section className="aboutus-hero" id="home">
          <div className="hero-cubes-background">
            <Cubes 
              gridSize={12}
              maxAngle={60}
              radius={5}
              borderStyle="2px dashed rgba(102, 126, 234, 0.4)"
              faceColor="rgba(26, 26, 46, 0.3)"
              rippleColor="#667eea"
              rippleSpeed={1.5}
              autoAnimate={true}
              rippleOnClick={true}
            />
          </div>
          <div className="hero-content">
            <div className="hero-title-wrapper">
              <h1 className="hero-title">ARK</h1>
              <div className="hero-title-underline"></div>
            </div>
            <p className="hero-subtitle">Moving Images</p>
            <div className="hero-decorative-line"></div>
            <div className="hero-scroll-indicator">
              <div className="scroll-arrow"></div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="aboutus-about-section" id="about" data-aos="fade-up" style={{padding: '100px 0', background: 'rgba(0, 0, 0, 0.8)', color: '#ffffff'}}>
          <div className="aboutus-about-container" style={{maxWidth: '1200px', margin: '0 auto', padding: '0 20px', textAlign: 'center'}}>
            <h2 className="aboutus-section-title" style={{fontSize: '3rem', fontWeight: '700', marginBottom: '2rem', color: '#ffffff'}}>About Our Studio</h2>
            <p data-aos="fade-up" data-aos-delay="200" style={{fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto 1.5rem', lineHeight: '1.8'}}>
              ARK Moving Studio is a creative haven where motion meets emotion.
              Built on the belief that every frame tells a story, ARK blends
              technical excellence with artistic vision to craft compelling visual
              narratives.
            </p>
            <p data-aos="fade-up" data-aos-delay="400" style={{fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto 1.5rem', lineHeight: '1.8'}}>
              ARK Moving Studio is more than a studio — it's a vessel for
              storytelling. Just like Noah's Ark carried life into a new world, ARK
              carries emotions, ideas, and creativity into timeless motion.
            </p>
            <button className="cta-btn" data-aos="fade-up" data-aos-delay="600" style={{
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              color: '#ffffff',
              border: 'none',
              padding: '15px 40px',
              borderRadius: '30px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              marginTop: '2rem'
            }}>
              <i className="fas fa-play" style={{marginRight: '10px'}}></i> Start Your Project
            </button>
          </div>
        </section>

        {/* Cinematic Section */}
        <section className="cinematic-section" data-aos="fade-up" style={{padding: '100px 0', background: 'rgba(0, 0, 0, 0.9)', color: '#ffffff'}}>
          <h2 className="cinematic-heading" style={{fontSize: '2.5rem', fontWeight: '700', textAlign: 'center', marginBottom: '3rem', letterSpacing: '2px'}}>HEARTFELT · CINEMATIC · TIMELESS</h2>
          <div className="cinematic-cards" style={{maxWidth: '1200px', margin: '0 auto', padding: '0 20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '30px'}}>
            <div className="cinematic-card" data-aos="fade-up" data-aos-delay="200" style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '15px',
              overflow: 'hidden',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <img src="/assets/img/AboutUs/Heartfelt.jpg" alt="Heartfelt Dialogues" style={{width: '100%', height: '250px', objectFit: 'cover'}} />
              <div className="cinematic-text" style={{padding: '30px'}}>
                <p className="cinematic-subtitle" style={{fontSize: '0.9rem', color: '#667eea', fontWeight: '600', marginBottom: '10px', letterSpacing: '1px'}}>POWERFUL STORYTELLING ►</p>
                <h3 className="cinematic-title" style={{fontSize: '1.5rem', fontWeight: '700', marginBottom: '15px', color: '#ffffff'}}>HEARTFELT DIALOGUES</h3>
                <p className="cinematic-description" style={{fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.8)', margin: '0'}}>
                  Intimate conversations that capture the humor, drama, emotion, and
                  love, forming the backbone of your film.
                </p>
              </div>
            </div>

            <div className="cinematic-card" data-aos="fade-up" data-aos-delay="400" style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '15px',
              overflow: 'hidden',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <img src="/assets/img/AboutUs/cinematic.webp" alt="Cinematic Excellence" style={{width: '100%', height: '250px', objectFit: 'cover'}} />
              <div className="cinematic-text" style={{padding: '30px'}}>
                <p className="cinematic-subtitle" style={{fontSize: '0.9rem', color: '#667eea', fontWeight: '600', marginBottom: '10px', letterSpacing: '1px'}}>PIONEERING CINEMA ►</p>
                <h3 className="cinematic-title" style={{fontSize: '1.5rem', fontWeight: '700', marginBottom: '15px', color: '#ffffff'}}>CINEMATIC EXCELLENCE</h3>
                <p className="cinematic-description" style={{fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.8)', margin: '0'}}>
                  With decades of film-making experience, we use state-of-the-art
                  technology to reinvent ourselves for every story.
                </p>
              </div>
            </div>

            <div className="cinematic-card" data-aos="fade-up" data-aos-delay="600" style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '15px',
              overflow: 'hidden',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <img src="/assets/img/AboutUs/tunes.jpg" alt="Timeless Tunes" style={{width: '100%', height: '250px', objectFit: 'cover'}} />
              <div className="cinematic-text" style={{padding: '30px'}}>
                <p className="cinematic-subtitle" style={{fontSize: '0.9rem', color: '#667eea', fontWeight: '600', marginBottom: '10px', letterSpacing: '1px'}}>SIGNATURE SOUNDSCAPES ►</p>
                <h3 className="cinematic-title" style={{fontSize: '1.5rem', fontWeight: '700', marginBottom: '15px', color: '#ffffff'}}>TIMELESS TUNES</h3>
                <p className="cinematic-description" style={{fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.8)', margin: '0'}}>
                  Every memory needs a melody. Our award-winning music, crafted
                  exclusively for you, harmonizes with your story.
                </p>
              </div>
            </div>
          </div>
        </section>

      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
